module.exports = __webpack_public_path__ + "img/组 741@2x.5e50c90b.webp";